// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-card--modern p[data-v-42f35683] {\n  max-width: 550px;\n  margin-left: auto;\n  margin-right: auto;\n}", ""]);
// Exports
module.exports = exports;
